import {Injectable} from '@angular/core';
import {SharedService} from "./sharedService";
import {PagerDataObject} from "../entities/pagerDataObject";
import { HttpClient } from "@angular/common/http";
import {Observable} from 'rxjs';

@Injectable()
export class CurrencyRateService {

  constructor(private http: HttpClient, private sharedService: SharedService) {
  }

  getData(query: string): Observable<PagerDataObject> {
    return this.http.get<PagerDataObject>(this.sharedService.apiUrl('api/currency-rates', query !== null ? ("/" + query) : ""));
  }

  columns: Array<any> = [
    {name: 'Currency 1', tag: 'CURRENCY_RATE.CURRENCY1', key: 'base', filtering: true, sorting: true},
    {name: 'Currency 2', tag: 'CURRENCY_RATE.CURRENCY2', key: 'quote', filtering: true, sorting: true},
    {name: 'Rate', tag: 'CURRENCY_RATE.RATE', key: 'rate', filtering: false, sorting: true},
    {name: 'Date', tag: 'CURRENCY_RATE.DATE', key: 'date', filtering: true, sorting: true, sortingOrder: 'desc'},
    {name: 'Source', tag: 'CURRENCY_RATE.SOURCE', key: 'source', filtering: true, sorting: true}
  ];

  getMetaInfo(): string[] {
    return ['base', 'quote', 'rate', 'date', 'source'];
  }

  getColumns(): string[] {
    return this.columns;
  }
}
